var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import { MediaQueryProvider } from 'react-media-query-hoc';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { checkAndLogPWAUsage, reloadIfVisitedLongAgo, reloadOnceWhenCrashed, } from '../pwa';
import { expandSidebarIfDesktop, isDesktop, smoothScroll } from '../app/ui';
import LogService, { createDerivedStateFromErrorLogger, logComponentDidCatch, } from '../utils/log';
import OtoError from '../components/common/OtoError';
import RestaurantMenuPage from './RestaurantMenuPage';
import { applyDiscountToWholeMenu } from '../app/discount-logic';
import iframeObserver from '../utils/iframe-observer';
import { isIframe } from '../utils/url-params';
import { getOrdersConfig } from 'App/app/logic';
import Restaurant from 'Utils/restaurant';
import TenantService from 'App/services/tenant';
import { initSentry } from 'App/services/sentry';
var COMPONENT_NAME = 'RestaurantMenuContainer';
var mediaQueries = {
    isDesktop: 'screen and (min-width: 992px)',
};
var inlineMenuAddonSets = function (menu) {
    if (!menu.addonFieldsSets || !menu.addonFieldsSets.length) {
        return menu;
    }
    var addonsDict = {};
    menu.addonFieldsSets.forEach(function (set) {
        addonsDict[set.id] = set;
    });
    var replaceSets = function (additionalFields) {
        if (!additionalFields) {
            return [];
        }
        var newAdditionalFields = [];
        for (var i = 0; i < additionalFields.length; i++) {
            if (additionalFields[i].type === 'set' && additionalFields[i].value) {
                var set = addonsDict[additionalFields[i].value];
                set && newAdditionalFields.push.apply(newAdditionalFields, __spreadArray([], __read(set.items), false));
            }
            else {
                newAdditionalFields.push(additionalFields[i]);
            }
        }
        return newAdditionalFields;
    };
    menu.categories.forEach(function (category) {
        category.items.forEach(function (item) {
            item.additionalFields = replaceSets(item.additionalFields);
        });
    });
    return menu;
};
var RestaurantMenuContainer = /** @class */ (function (_super) {
    __extends(RestaurantMenuContainer, _super);
    function RestaurantMenuContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.shouldRedirectToLubje = function () {
            if (isIframe()) {
                return false;
            }
            return (window.location.href.includes('otostolik') &&
                _this.state.restaurant &&
                Restaurant.hasLubjeOrdersList(_this.state.restaurant));
        };
        reloadIfVisitedLongAgo();
        try {
            var restaurant = window.restaurant;
            // todo refactor later, so no orders-config needed
            var restaurantDetails = getOrdersConfig(restaurant);
            var isMenuEmpty = false;
            if (restaurant.menu) {
                if (restaurantDetails && restaurantDetails.discountPercent) {
                    restaurant.menu = applyDiscountToWholeMenu(restaurant.menu, restaurantDetails.discountPercent, restaurantDetails.roundDiscount || false);
                }
                restaurant.menu = inlineMenuAddonSets(restaurant.menu);
                var isNotDisabled_1 = function (item) {
                    return !item.isDisabled;
                };
                if (restaurant.menu.categories) {
                    restaurant.menu.categories.forEach(function (category) {
                        category.items = category.items.filter(isNotDisabled_1);
                        category.items.forEach(function (item) {
                            item.category = category.name;
                            if (!!item.additionalFields) {
                                item.additionalFields =
                                    item.additionalFields.filter(isNotDisabled_1);
                            }
                        });
                    });
                    restaurant.menu.categories = restaurant.menu.categories.filter(function (category) { return category.items.length; });
                }
                else {
                    isMenuEmpty = true;
                }
            }
            else {
                isMenuEmpty = true;
            }
            _this.state = {
                restaurantDetails: restaurantDetails,
                restaurant: restaurant,
                hasError: false,
                isMenuEmpty: isMenuEmpty,
            };
        }
        catch (e) {
            _this.state = {
                hasError: true,
            };
            LogService.error("".concat(COMPONENT_NAME, " constructor catch"), e, {
                instant: true,
            });
            reloadOnceWhenCrashed();
        }
        return _this;
    }
    RestaurantMenuContainer.prototype.componentDidMount = function () {
        var notice = document.getElementById('network-needed-notice');
        notice && notice.remove();
        checkAndLogPWAUsage(COMPONENT_NAME);
        expandSidebarIfDesktop();
        var mainNavHeight = $('#mainNav').outerHeight() || 0;
        var categoriesMenuHeight = $('.takeout-nav').outerHeight() || 0;
        var scrollOffset = isDesktop()
            ? mainNavHeight + categoriesMenuHeight - 10
            : mainNavHeight +
                categoriesMenuHeight +
                ($('.takeout-sidebar').outerHeight() || 0);
        smoothScroll(scrollOffset);
        ReactGA.initialize(TenantService.getGoogleAnalyticsTrackingId());
        iframeObserver.initIfApplicable({
            onReady: function () { return setTimeout(expandSidebarIfDesktop, 100); },
        });
        if (this.shouldRedirectToLubje()) {
            window.location.href = window.location.href.replace('otostolik', 'lubje');
        }
    };
    RestaurantMenuContainer.prototype.componentDidCatch = function (error, info) {
        logComponentDidCatch(COMPONENT_NAME, error, info);
    };
    RestaurantMenuContainer.prototype.render = function () {
        var _a = this.state, hasError = _a.hasError, otherState = __rest(_a, ["hasError"]);
        return hasError ? (React.createElement(OtoError, { className: "mx-2 mt-2" })) : (React.createElement(MediaQueryProvider, { queries: mediaQueries },
            React.createElement(RestaurantMenuPage, __assign({}, otherState, { onPlace: false })),
            React.createElement(ToastContainer, null)));
    };
    RestaurantMenuContainer.displayName = COMPONENT_NAME;
    RestaurantMenuContainer.getDerivedStateFromError = createDerivedStateFromErrorLogger(COMPONENT_NAME);
    return RestaurantMenuContainer;
}(React.PureComponent));
export default RestaurantMenuContainer;
initSentry();
ReactDOM.render(React.createElement(RestaurantMenuContainer, null), document.getElementById('takeout'));
